
<div class="container-fluid">

  <div class="d-flex gap-1">

    <mat-form-field appearance="outline">
      <mat-label>Centre Name</mat-label>
      <mat-select [formControl]="SelectCentre" (selectionChange)="onCentreChange($event)">
        <mat-option value="All">All Centres</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From date" [formControl]="startDate">
        <input matEndDate placeholder="To date" [formControl]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button mat-mini-fab color="accent" (click)="search()">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="clearAll()">
      <mat-icon>clear</mat-icon>
    </button>

  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Education MOM List</h2>
      </li>

      <li class="dropdown m-l-20">
        <label><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)="applyFilter($event)" aria-label="Search box">
      </li>
    </ul>

    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab class="mr-2" color="primary" (click)="addMom()" permission="Education MOM"
                [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
      <li class="me-2">
        <button
          mat-mini-fab
          color="accent"
          matTooltip="Download Excel"
          (click)="downloadExcel()" permission="Education MOM"
          [permissionTypes]="[PermissionType.EXCEL, PermissionType.ALL]">
          <mat-icon>download</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
      <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date</th>
      <td mat-cell *matCellDef="let row"> {{ row.date?.toDate() | date }}</td>
    </ng-container>

    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre</th>
      <td mat-cell *matCellDef="let row"> {{ row.centreName }}</td>
    </ng-container>

    <ng-container matColumnDef="place">
      <th mat-header-cell *matHeaderCellDef> Place</th>
      <td mat-cell *matCellDef="let row"> {{ row.place }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Type</th>
      <td mat-cell *matCellDef="let row"> {{ row.type }}</td>
    </ng-container>

    <ng-container matColumnDef="suggestions">
      <th mat-header-cell *matHeaderCellDef>Suggestion</th>

      <td mat-cell *matCellDef="let row">
        <div class="suggestion-content">

          <!-- Empty content -->
          <span *ngIf="!row.suggestions || row.suggestions.trim() === ''">NA</span>

          <!-- Content with media - always show with small images, no read more -->
          <div *ngIf="row.suggestions && hasMediaContent(row.suggestions)"
               class="media-content"
               [innerHTML]="getDisplayContent(row)">
          </div>

          <!-- Text only content - with read more/less -->
          <div *ngIf="row.suggestions && !hasMediaContent(row.suggestions)">
            <span [innerHTML]="getDisplayContent(row)"></span>

            <!-- Show "..." and Read More button for long text -->
            <ng-container *ngIf="shouldShowReadMore(row)">
              <span *ngIf="!row._expanded">&nbsp;...</span>
              <a class="read-more-link" (click)="toggleReadMore(row)">
                {{ row._expanded ? 'Read Less' : 'Read More' }}
              </a>
            </ng-container>
          </div>

        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent"
                (click)="view(row)"
                permission="Education MOM"
                [permissionTypes]="[PermissionType.VIEW, PermissionType.ALL]">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="edit(row)" permission="Education MOM"
                [permissionTypes]="[PermissionType.EDIT]">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="delete(row.id)" permission="Education MOM"
                [permissionTypes]="[PermissionType.ARCHIVE]">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100,250,500]" showFirstLastButtons></mat-paginator>
</div>
